// ── LegalModals — 개인정보 처리방침 + 보안 정책 모달 ──
// 한국 개인정보보호법 25조·38조 + 신뢰 어필
// App에서 footer 링크 → 모달 띄우기

import React from 'react';

export function PrivacyPolicyModal({ isOpen, onClose, notice, okLabel }) {
  if (!isOpen) return null;
  return (
    <Modal title="🔒 개인정보 처리방침" onClose={onClose} notice={notice} okLabel={okLabel}>
      <Section title="1. 수집하는 개인정보 항목 및 수집 방법">
        <p>셈핏은 다음 정보를 수집합니다:</p>
        <ul>
          <li><strong>회원가입 시</strong> (Google 로그인): 이메일 주소, 이름, 프로필 사진</li>
          <li><strong>서비스 이용 시</strong>: 매장명, 사업자번호, 매출·매입 거래 내역, 영수증 사진, 메뉴·식재료 정보, 직원 인건비 데이터</li>
          <li><strong>자동 수집</strong>: 접속 IP, 쿠키, 사용 로그 (서비스 개선 목적)</li>
        </ul>
        <p>비밀번호는 <strong>수집하지 않습니다</strong>. Google OAuth 인증만 사용합니다.</p>
      </Section>

      <Section title="2. 개인정보 수집·이용 목적">
        <ul>
          <li>서비스 제공: 매장 운영 데이터 저장·표시·분석</li>
          <li>회원 식별 및 본인 확인</li>
          <li>법령에 따른 의무 이행 (세무 자료 5년 보관 등)</li>
          <li>서비스 개선 및 통계 분석 (개인 식별 정보 제외 익명 집계)</li>
        </ul>
      </Section>

      <Section title="3. 개인정보 보유 및 이용 기간">
        <ul>
          <li><strong>회원 정보</strong>: 회원 탈퇴 시 즉시 영구 삭제</li>
          <li><strong>거래 내역·영수증</strong>: 세법상 5년 보관 (국세기본법 85조의3)</li>
          <li><strong>접속 로그</strong>: 3개월 보관 후 자동 삭제</li>
        </ul>
        <p>회원 탈퇴 시 위 세법상 보관 의무가 없는 모든 데이터는 즉시 영구 삭제됩니다.</p>
      </Section>

      <Section title="4. 개인정보 제3자 제공">
        <p>셈핏은 사용자의 개인정보를 외부에 제공하지 <strong>않습니다</strong>. 단, 다음의 경우 예외로 합니다:</p>
        <ul>
          <li>사용자가 사전에 동의한 경우</li>
          <li>법령 또는 수사 목적으로 정당한 절차에 따라 요청된 경우</li>
        </ul>
      </Section>

      <Section title="5. 개인정보 처리 위탁">
        <p>안정적인 서비스 제공을 위해 다음 회사에 일부 업무를 위탁합니다:</p>
        <ul>
          <li><strong>Google Cloud (Firebase)</strong> — 데이터 저장·인증·호스팅</li>
          <li><strong>Vercel</strong> — 웹 호스팅</li>
          <li><strong>Naver Cloud (CLOVA OCR)</strong> — 영수증 OCR 처리 (이미지는 응답 후 즉시 폐기)</li>
          <li><strong>Anthropic (Claude)</strong> — AI 데이터 구조화 (텍스트만, 응답 후 즉시 폐기)</li>
        </ul>
      </Section>

      <Section title="5-2. 사업 양도·합병 시 개인정보 이전">
        <p>회사가 사업의 전부 또는 일부를 <strong>양도·합병·분할</strong>하는 경우, 사용자의 개인정보는 양수·합병 법인에 이전될 수 있습니다.</p>
        <ul>
          <li>이전 사실 및 양수인의 명칭은 최소 <strong>30일 전</strong> 이메일·앱 내 공지·서비스 홈페이지를 통해 통지합니다.</li>
          <li>사용자는 통지일로부터 30일 이내에 <strong>개인정보 이전을 거부</strong>할 수 있으며, 거부 시 회원 탈퇴 처리되고 모든 개인정보는 즉시 영구 삭제됩니다 (세법상 보관 의무 데이터는 별도).</li>
          <li>이전 후 양수인은 본 개인정보처리방침의 의무를 그대로 승계합니다. 사용자 동의 없는 목적 변경·범위 확대는 금지됩니다.</li>
          <li>개인정보보호법 제27조에 따른 절차를 준수합니다.</li>
        </ul>
      </Section>

      <Section title="6. 정보주체의 권리 (개인정보보호법 38조)">
        <p>사용자는 언제든지 다음 권리를 행사할 수 있습니다:</p>
        <ul>
          <li><strong>열람 권리</strong>: 본인 데이터 조회 (셈핏 앱 내 모든 페이지에서 확인 가능)</li>
          <li><strong>정정·삭제 권리</strong>: 잘못된 데이터 수정 또는 삭제</li>
          <li><strong>처리정지 권리</strong>: 본인 데이터 처리 중단 요청</li>
          <li><strong>회원 탈퇴 권리</strong>: 설정 → 회원 탈퇴 → 즉시 모든 데이터 영구 삭제</li>
        </ul>
      </Section>

      <Section title="7. 개인정보 안전성 확보 조치">
        <ul>
          <li><strong>암호화</strong>: HTTPS 통신 (TLS 1.2+) + Google Cloud KMS at-rest 암호화</li>
          <li><strong>접근 통제</strong>: Firestore 보안 규칙로 사용자별 데이터 완전 격리</li>
          <li><strong>인증</strong>: Google OAuth (비밀번호 저장 안 함)</li>
          <li><strong>관리자 접근 제한</strong>: 운영진도 사용자 데이터 임의 조회 불가 (익명 통계만 접근)</li>
        </ul>
      </Section>

      <Section title="8. 개인정보 보호책임자">
        <p>
          이메일: <strong>u012me@gmail.com</strong><br/>
          문의: 셈핏 앱 내 도움말 또는 위 이메일로 연락
        </p>
      </Section>

      <Section title="9. 고지의 의무">
        <p>본 처리방침은 2026년 5월 13일부터 시행됩니다. 변경 시 셈핏 앱 내 공지로 안내합니다.</p>
      </Section>
    </Modal>
  );
}

export function TermsOfServiceModal({ isOpen, onClose, notice, okLabel }) {
  if (!isOpen) return null;
  return (
    <Modal title="📜 셈핏 이용약관" onClose={onClose} notice={notice} okLabel={okLabel}>
      <Section title="제1조 (목적)">
        <p>본 약관은 따박(이하 "회사")이 제공하는 셈핏(SEMFIT) 서비스(이하 "서비스")의 이용과 관련하여 회사와 회원 사이의 권리·의무 및 책임사항을 규정함을 목적으로 합니다.</p>
      </Section>

      <Section title="제2조 (정의)">
        <ul>
          <li>"서비스": 매장 운영을 위한 거래장부, 레시피, 원가 분석, 세무 도우미, 공동구매 등의 SaaS 도구</li>
          <li>"회원": 본 약관에 동의하고 가입을 완료한 사장님·매장 운영자</li>
          <li>"콘텐츠": 회원이 서비스에 입력·업로드한 매출, 매입, 영수증, 레시피, 직원 정보 등 일체의 데이터</li>
        </ul>
      </Section>

      <Section title="제3조 (약관의 효력 및 변경)">
        <ul>
          <li>본 약관은 서비스 화면에 게시하거나 회원에게 공지함으로써 효력이 발생합니다.</li>
          <li>회사는 관련 법령을 위배하지 않는 범위에서 약관을 개정할 수 있으며, 개정 시 최소 7일 전(회원에게 불리한 경우 30일 전) 공지합니다.</li>
        </ul>
      </Section>

      <Section title="제4조 (서비스 제공)">
        <ul>
          <li>회사는 회원에게 다음 서비스를 제공합니다: 거래장부 관리, 영수증 OCR, 메뉴·레시피 원가 계산, 부가세·종합소득세 도우미, 공동구매 안건, 매장 운영 분석 도구</li>
          <li>서비스는 연중무휴 24시간 제공함을 원칙으로 합니다. 단, 점검·장애 등의 사유로 일시 중단될 수 있습니다.</li>
          <li>일부 기능은 유료 플랜(Pro) 가입자에게만 제공됩니다.</li>
        </ul>
      </Section>

      <Section title="제5조 (회원의 의무)">
        <ul>
          <li>회원은 본인의 매장 정보와 거래 내역을 사실대로 입력해야 합니다.</li>
          <li>회원은 다음 행위를 해서는 안 됩니다: 타인 계정 도용, 허위 정보 등록, 서비스 무단 복제·해킹 시도, 다른 회원의 콘텐츠 무단 조회·이용</li>
          <li>회원은 본인의 로그인 정보를 안전하게 관리해야 하며, 이를 타인에게 양도·대여할 수 없습니다.</li>
        </ul>
      </Section>

      <Section title="제6조 (콘텐츠의 권리)">
        <ul>
          <li>회원이 입력한 콘텐츠의 저작권 및 소유권은 <strong>회원에게 귀속</strong>됩니다.</li>
          <li>회사는 회원의 콘텐츠를 서비스 제공·운영을 위한 목적으로만 이용하며, 동의 없이 제3자에게 제공하지 않습니다.</li>
          <li>익명 통계·시장 인텔리전스 기능에 활용하기 위해서는 회원의 별도 동의를 받습니다.</li>
        </ul>
      </Section>

      <Section title="제7조 (유료 서비스 및 결제)">
        <ul>
          <li>유료 상품(평생 Pro 이용권)의 가격과 결제 방법은 서비스 화면에 명시합니다.</li>
          <li>평생 Pro 이용권은 <strong>1회 결제 상품</strong>으로, 자동 갱신이나 추가 청구가 없습니다.</li>
          <li>결제 대행은 래피드(Latpeed), Toss Payments 등 결제 플랫폼을 통해 처리되며, 회사는 카드 정보를 직접 보관하지 않습니다.</li>
          <li>"평생"이란 본 서비스가 제공되는 기간 전체를 의미합니다. 서비스 종료 시 제13조(서비스 중단 및 종료)에 따릅니다.</li>
          <li><strong>영수증 OCR 공정 사용</strong>: AI 처리 비용이 발생하는 영수증 OCR 기능은 평생 Pro 기준
            <strong> 총 1,000장 + 월 100장</strong>이 기본 제공됩니다 (무료 체험은 월 20장).
            기본 제공량 소진 시 충전권(100장, 3,000원)을 구매·등록하여 계속 이용할 수 있습니다.
            이 제한은 구매 전 상품 페이지에 고지되며, OCR 외 기능에는 사용량 제한이 없습니다.</li>
        </ul>
      </Section>

      <Section title="제8조 (환불 정책)">
        <ul>
          <li>평생 Pro 이용권·충전권: 결제 후 <strong>7일 이내이며 코드를 등록(사용 개시)하지 않은 경우</strong> 전액 환불 (「전자상거래법」 제17조 청약철회)</li>
          <li>코드 등록 후 또는 결제 후 7일 경과 시에는 「전자상거래법」 등 관련 법령이 정한 범위 내에서 환불 여부를 결정합니다.</li>
          <li>회사 귀책 사유(서비스 중단·기능 불량 등)로 인한 환불 요청 시 사용 여부와 무관하게 전액 환불하며, 서비스 종료에 따른 환불은 제13조를 따릅니다.</li>
        </ul>
      </Section>

      <Section title="제9조 (회원 탈퇴 및 자격 상실)">
        <ul>
          <li>회원은 언제든 탈퇴할 수 있으며, 회사는 즉시 해당 회원의 개인정보를 파기합니다. 단, 세법상 보관 의무가 있는 거래 데이터는 5년간 별도 보관 후 파기합니다.</li>
          <li>회원이 본 약관 또는 관련 법령을 위반한 경우 회사는 사전 통지 후 이용 제한 또는 자격 박탈할 수 있습니다.</li>
        </ul>
      </Section>

      <Section title="제10조 (서비스 책임의 한계)">
        <ul>
          <li>회사는 천재지변, 통신장애, 정전 등 불가항력으로 인한 서비스 중단에 대해 책임지지 않습니다.</li>
          <li>세무·회계 관련 계산 결과는 참고용이며, 실제 세무 신고는 회원이 세무사·국세청 절차에 따라 직접 책임지고 진행해야 합니다.</li>
          <li>공동구매 안건은 회원 간 거래의 매개일 뿐이며, 회사는 거래 결과(품질·배송·결제 등)에 대해 책임지지 않습니다.</li>
        </ul>
      </Section>

      <Section title="제11조 (분쟁 해결)">
        <ul>
          <li>본 약관에 명시되지 않은 사항은 대한민국 관련 법령에 따릅니다.</li>
          <li>서비스 이용 중 발생한 분쟁의 관할 법원은 회사 본점 소재지 관할 법원으로 합니다.</li>
        </ul>
      </Section>

      <Section title="제12조 (권리·의무의 양도)">
        <ul>
          <li>회사는 사업 운영의 효율성을 위해 본 약관에 따른 권리·의무의 전부 또는 일부를 <strong>제3자에게 양도·합병·분할</strong>할 수 있습니다.</li>
          <li>회사는 양도·합병·분할 시 최소 <strong>30일 전</strong> 회원에게 이메일·공지사항·앱 내 알림 등을 통해 통지합니다.</li>
          <li>회원이 양도에 동의하지 않는 경우, 통지일로부터 30일 이내에 <strong>회원 탈퇴</strong>를 요청할 수 있으며, 회사는 세법상 보관 의무가 없는 모든 데이터를 즉시 영구 삭제합니다.</li>
          <li>양도 이후 본 서비스의 운영 주체는 변경될 수 있으나, 회원의 기존 권리(평생 이용권, 데이터 소유권 등)는 그대로 승계됩니다.</li>
        </ul>
      </Section>

      <Section title="제13조 (서비스 중단 및 종료)">
        <ul>
          <li>회사가 부득이하게 서비스 전체를 종료하는 경우, 종료일로부터 최소 <strong>90일 전</strong> 이메일·앱 내 공지로 통지합니다.</li>
          <li>서비스 종료 시 평생 Pro 이용권 구매자에게는 다음 기준으로 환불합니다:
            구매일로부터 <strong>36개월 미만</strong> 사용자에 한해, <em>결제 금액 × 잔여 개월수 ÷ 36</em> (1개월 미만은 올림) 을 환불합니다.
            구매 후 36개월 이상 이용한 경우 충분한 사용 기간이 제공된 것으로 봅니다.</li>
          <li>미사용 충전권 잔량은 사용 기간과 무관하게 잔여 장수 비율로 환불합니다.</li>
          <li>회사는 종료일까지 회원이 자신의 데이터를 <strong>엑셀 파일로 내보내기</strong> 할 수 있도록 보장합니다.</li>
        </ul>
      </Section>

      <Section title="부칙">
        <p>본 약관은 2026년 5월 17일부터 시행합니다.</p>
        <p style={{ marginTop: 4, fontSize: 11, color: '#6b7280' }}>
          제12조(권리·의무의 양도) 추가 시행: 2026년 5월 18일 ·
          제7조(OCR 공정 사용)·제8조(환불)·제13조(서비스 중단 및 종료) 개정 시행: 2026년 7월 31일
        </p>
        <p style={{ marginTop: 8, fontSize: 11, color: '#6b7280' }}>
          사업자: 따박 · 운영자 문의: u012me@gmail.com
        </p>
      </Section>
    </Modal>
  );
}

export function SecurityPolicyModal({ isOpen, onClose, notice, okLabel }) {   // V147 notice·okLabel
  if (!isOpen) return null;
  return (
    <Modal title="🛡️ 셈핏 보안 정책" onClose={onClose} notice={notice} okLabel={okLabel}>
      <div style={{
        padding: '14px 16px', background: '#FAFAFA',
        borderRadius: 8, border: '1px solid #FED7AA',
        marginBottom: 18,
      }}>
        <div style={{ fontSize: 13, fontWeight: 800, color: '#18181B', marginBottom: 4 }}>
          한 줄 요약
        </div>
        <div style={{ fontSize: 12, color: '#1f2937', lineHeight: 1.6 }}>
          사장님 데이터는 사장님 폴더에만 저장됩니다. Google Cloud Firebase 위에서 보안 규칙로 격리되어 있어 다른 사용자는 물론 셈핏 운영진도 임의 조회할 수 없습니다.
        </div>
      </div>

      <SecurityFeature
        emoji="🔐"
        title="사장님 데이터는 셈핏도 못 봅니다"
        desc="Firestore 보안 규칙(request.auth.uid == userId)으로 본인 폴더만 접근 가능. 모든 다른 경로는 명시적 차단(default deny). 셈핏 운영진도 익명 통계만 접근하며, 사용자 데이터 임의 조회 권한이 없습니다."
      />

      <SecurityFeature
        emoji="☁️"
        title="Google Cloud 기반 — 은행급 암호화"
        desc="데이터는 Google Cloud KMS로 at-rest 자동 암호화됩니다. 전송 구간은 HTTPS(TLS 1.2+)로 강제. 인프라는 ISO 27001 / SOC 2 / PCI DSS 인증을 받은 Google Cloud입니다."
      />

      <SecurityFeature
        emoji="📷"
        title="영수증 사진 5년 자동 보관 — 본인 폴더만"
        desc="세법상 5년 보관 의무를 셈핏이 자동 처리합니다. Firebase Storage의 users/{본인UID}/receipts 경로에만 저장되며, 보안 규칙로 다른 사용자 접근 불가. 위변조 방지 형식으로 보관되어 세무조사 증빙으로 인정됩니다."
      />

      <SecurityFeature
        emoji="🔑"
        title="비밀번호 저장 안 함 — Google 로그인 사용"
        desc="셈핏은 사장님의 비밀번호 자체를 저장하지 않습니다. Google OAuth만 사용하며, 인증 책임은 Google이 담당합니다. Google 계정에 2단계 인증을 설정하시면 보안이 더욱 강화됩니다."
      />

      <SecurityFeature
        emoji="📤"
        title="데이터는 사장님 것 — 언제든 삭제·다운로드"
        desc="회원 탈퇴 시 모든 데이터가 즉시 영구 삭제됩니다 (세법상 보관 의무 있는 데이터는 별도 안내). 본인 데이터 엑셀 다운로드 기능 제공 예정. 세무사 인계도 데이터 export로 가능."
      />

      <div style={{
        marginTop: 18, padding: '12px 14px', background: '#FAFAFA',
        borderRadius: 8, border: '1px dashed #D4D4D8',
        fontSize: 11, color: '#78350f', lineHeight: 1.6,
      }}>
        ⚠ <strong>보안 사고 신고</strong>: 의심스러운 활동이나 보안 취약점을 발견하시면 u012me@gmail.com으로 즉시 알려주세요. 24시간 안에 대응합니다.
      </div>
    </Modal>
  );
}

// ── 공통 모달 셸 ──
function Modal({ title, onClose, children, notice, okLabel }) {   // V144 notice·okLabel: 중국어 화면 안내
  return (
    <div onClick={onClose} style={{
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      zIndex: 1200, padding: 12,
    }}>
      <div onClick={e => e.stopPropagation()} style={{
        background: '#fff', borderRadius: 14, width: 720, maxWidth: '100%',
        maxHeight: '90vh', display: 'flex', flexDirection: 'column',
        boxShadow: '0 10px 50px rgba(0,0,0,0.25)',
      }}>
        <div style={{
          padding: '16px 22px', borderBottom: '1px solid #eee',
          display: 'flex', alignItems: 'center', gap: 14, background: '#f9fafb',
          flexShrink: 0,
        }}>
          <div style={{ flex: 1, fontSize: 17, fontWeight: 800 }}>{title}</div>
          <button onClick={onClose} style={{
            border: 'none', background: 'transparent', fontSize: 22,
            color: '#9ca3af', cursor: 'pointer',
          }}>×</button>
        </div>
        {notice && (
          <div data-legal-notice style={{ padding: '10px 22px', background: '#FFF7ED', color: '#9A3412', fontSize: 13, fontWeight: 600, borderBottom: '1px solid #FED7AA', flexShrink: 0 }}>
            {notice}
          </div>
        )}
        <div style={{
          padding: '20px 22px', overflow: 'auto', flex: 1,
          color: '#1f2937', fontSize: 13, lineHeight: 1.7,
        }}>
          {children}
        </div>
        <div style={{
          padding: '12px 22px', borderTop: '1px solid #eee',
          display: 'flex', justifyContent: 'flex-end', background: '#fff',
          flexShrink: 0,
        }}>
          <button onClick={onClose} style={{
            padding: '10px 22px', borderRadius: 8, border: 'none',
            background: '#FF6F0F', color: '#fff',
            fontSize: 13, fontWeight: 700, cursor: 'pointer',
          }}>{okLabel || '확인'}</button>
        </div>
      </div>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <div style={{ marginBottom: 18 }}>
      <h3 style={{
        fontSize: 14, fontWeight: 800, color: '#1a1a1a',
        margin: '0 0 8px 0', paddingBottom: 4,
        borderBottom: '1px solid #e5e7eb',
      }}>{title}</h3>
      <div style={{ paddingLeft: 4 }}>{children}</div>
    </div>
  );
}

function SecurityFeature({ emoji, title, desc }) {
  return (
    <div style={{
      marginBottom: 14, padding: '14px 16px',
      background: '#fff', borderRadius: 10,
      border: '1px solid #e5e7eb',
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 6 }}>
        <span style={{ fontSize: 22 }}>{emoji}</span>
        <h3 style={{ fontSize: 14, fontWeight: 800, margin: 0, color: '#1a1a1a' }}>
          {title}
        </h3>
      </div>
      <div style={{ fontSize: 12, color: '#4b5563', lineHeight: 1.7, paddingLeft: 32 }}>
        {desc}
      </div>
    </div>
  );
}
